import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.scss']
})

export class LoginSignupComponent implements OnInit {
  activeTab = 'login';
  user_error = '';
  password_error = '';
  public onlineOffline: boolean = navigator.onLine;
  loginForm = {};
  signForm = {};
  // signForm.countryCode = '';

  modalRef: NgbModalRef;
  closeResult: any;

  showCaps = false;

  @Output() closeCountryModal = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
    // this.logService.printLog(this.signForm['password'].type);
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/login-signup/login-signup.component.ts